<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="卡号">
              <a-input v-model.trim="queryParam.queryNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="卡类型">
              <a-select v-model="queryParam.type" default-value="0" placeholder="请选择">
                <a-select-option value>全选</a-select-option>
                <a-select-option
                  v-for="(item, index) in typeSelect"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="启用状态">
                <a-select v-model="queryParam.used" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in usedSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button>
      <a-button
        style="margin-left: 8px"
        type="primary"
        icon="plus-square"
        @click="handleBatchAdd()"
      >批量新建</a-button>
      <a-button
        style="margin-left: 8px"
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
      <a-upload
        accept=".xls, .xlsx"
        :showUploadList="false"
        :action="config.importCardUrl"
        :beforeUpload="beforeUpload"
        @change="handleChange"
      >
        <a-button style="margin-left: 8px" type="primary" icon="plus">导入</a-button>
      </a-upload>
      <a-button style="margin-left: 8px" type="primary" @click="downLoad()">模板下载</a-button>
      <a-button style="margin-left: 8px" type="primary" @click="handleExport()">导出</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x:500 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDel(record)">删除</a>
      </span>
    </s-table>

    <a-modal
      title="编辑"
      style="top: 20px;"
      :width="560"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item label="卡类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select
            v-model="mdl.type"
            placeholder="请选择卡类型"
            v-decorator="['type',
            { initialValue: mdl.type, rules: [{ required: true, message: '请选择卡类型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="印刷号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input v-model="mdl.cardNo" placeholder="编号" />
        </a-form-item>

        <a-form-item
          v-if="mdl.type == 2 || mdl.type == 3"
          label="ID卡号"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            v-model="mdl.idNo"
            placeholder="ID卡号"
             oninput="if(value.length > 24)value = value.slice(0, 24)"
            v-decorator="['idNo',
            { initialValue: mdl.idNo, rules: [{ required: true, message: '请输入ID卡号'}]}]"
          />
        </a-form-item>

        <a-form-item
          v-if="mdl.type == 1 || mdl.type == 3"
          label="IC卡号"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            v-model="mdl.icNo"
            placeholder="IC卡号"
            oninput="if(value.length > 10)value = value.slice(0, 10)"
            v-decorator="['icNo',
            { initialValue: mdl.icNo, rules: [{ required: true, message: '请输入IC卡号'}]}]"
          />
        </a-form-item>

        <a-form-item
          v-if="mdl.id"
          label="启/禁用"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            v-model="mdl.used"
            placeholder="请选择启/禁用"
            v-decorator="['used',
            { initialValue: mdl.used, rules: [{ required: true, message: '请选择启/禁用'}]}]"
          >
            <a-select-option
              v-for="(item, index) in usedSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="批量新建"
      style="top: 20px;"
      destroyOnClose
      :width="800"
      v-model="batchAddModel"
      @ok="handleBatchAddOk"
      :confirmLoading="confirmLoading"
    >
      <div>
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="卡类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 16 }">
              <a-select
                v-model="mdl.type"
                style="width: 100%;"
                placeholder="请选择卡类型"
                @change="cardTypeChange"
                v-decorator="['type',
                { initialValue: mdl.type, rules: [{ required: true, message: '请选择卡类型'}]}]"
              >
                <a-select-option
                  v-for="(item, index) in typeSelect"
                  :key="index"
                  :value="item.value"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="新增条数" :label-col=" { span: 12 }" :wrapper-col=" { span: 12 }">
              <a-select v-model="addCount" style="width: 100%;">
                <a-select-option
                  v-for="(item, index) in addCountSelect"
                  :key="index"
                  :value="item"
                >{{ item }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="印刷号" :label-col=" { span: 12 }" :wrapper-col=" { span: 12 }">
              <a-switch
                v-model="showYS"
                @change="showYSChange"
                checkedChildren="显示"
                unCheckedChildren="隐藏"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </div>
      <div>
        <a-row :gutter="48">
          <a-alert v-if="tipMsg" :message="tipMsg" :type="tipType" showIcon />
          <div v-for="i in addCount">
            <a-col v-if="mdl.type == 1 || mdl.type == 3" :md="24/batchCol" :sm="72/batchCol">
              <a-form-item label="IC卡号" :label-col=" { span: 6 }" :wrapper-col=" { span: 18 }">
                <a-input
                  class="bno bicno"
                  :id="'bic' + i"
                  placeholder="IC卡号"
                  oninput="if(value.length > 10)value = value.slice(0, 10)"
                  @pressEnter="bnoEnter"
                />
              </a-form-item>
            </a-col>
            <a-col v-if="mdl.type == 2 || mdl.type == 3" :md="24/batchCol" :sm="72/batchCol">
              <a-form-item label="ID卡号" :label-col=" { span: 6 }" :wrapper-col=" { span: 18 }">
                <a-input
                  class="bno bidno"
                  :id="'bid' + i"
                  placeholder="ID卡号"
                  oninput="if(value.length > 24)value = value.slice(0, 24)"
                  @pressEnter="bnoEnter"
                />
              </a-form-item>
            </a-col>
            <a-col v-if="showYS" :md="24/batchCol" :sm="72/batchCol">
              <a-form-item label="印刷号" :label-col=" { span: 6 }" :wrapper-col=" { span: 18 }">
                <a-input
                  class="bno bysno"
                  :id="'bys' + i"
                  placeholder="印刷号"
                  @pressEnter="bnoEnter"
                />
              </a-form-item>
            </a-col>
          </div>
        </a-row>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { STable } from '@/components'
import { cardPage, cardUpdate, cardSave, cardDelete, cardSaveBatch } from '../../api/basic'
import Bus from '@/layouts/bus'
import config from '@/config/defaultSettings'
import { formatDate } from '@/utils/date'
export default {
  name: 'Card',
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      visible: false, // 编辑面板显示和隐藏变量
      confirmLoading: false,
      batchAddModel: false, // 批量新建面板显示和隐藏变量
      addCount: 5, // 默认新增条数
      addCountSelect: [5, 10, 15, 20, 25, 30, 50, 100], // 新增条数选择
      showYS: true, // 显示印刷号开关
      batchCol: 2, // 动态分列变量
      tipMsg: '', // 提示信息
      tipType: 'info', // 提示类型
      cardList: [], // 批量增加卡号数组
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '40px',
          fixed:"left"
        },
        {
          title: '卡类型',
          dataIndex: 'typeName',
          width: '120px',
        },
        {
          title: '印刷号',
          dataIndex: 'cardNo',
          width: '120px',
        },
        {
          title: 'ID卡号',
          dataIndex: 'idNo',
          width: '120px',
        },
        {
          title: 'IC卡号',
          dataIndex: 'icNo',
          width: '120px',
        },
        {
          title: '启用状态',
          dataIndex: 'usedName',
          width: '120px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
       /*  {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },*/
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        }
      ],
      // 所属菜单下拉
      typeSelect: null,
      usedSelect: null,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return cardPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
  },
  methods: {
    loadSelect() {
      // 从后台拉去下拉列表数据
      this.typeSelect = this.$store.getters.codeList.basic_card_type
      this.usedSelect = this.$store.getters.codeList.sys_used
    },
    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      this.mdl = Object.assign({}, record)
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleAdd() {
      this.mdl = {}
      this.form = this.$form.createForm(this)
      this.visible = true
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            cardUpdate(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(() => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            cardSave(Object.assign({}, this.mdl))
              .then(res => {
                if (res.code === '0') {
                  this.$refs.table.refresh()
                  this.visible = false
                }
              })
              .catch(() => {
                console.log(e)
              })
              .finally(() => {
                this.confirmLoading = false
              })
          }
        }
      })
    },
    handleBatchAdd() {
      this.batchAddModel = true
      this.mdl.type = '1'
      this.showYS = true
      this.batchCol = 2 // 初始纵排分隔二分
      this.tipMsg = ''
      this.cardList = []
    },
    cardTypeChange() {
      // 纵排分隔处理
      this.batchCol = 0
      if (this.mdl.type == 1 || this.mdl.type == 2) {
        this.batchCol = 1
      } else if (this.mdl.type == 3) {
        this.batchCol = 2
      }
      if (this.showYS) {
        this.batchCol = this.batchCol + 1
      }
    },
    showYSChange() {
      // 显示或者隐藏印刷号
      if (this.showYS) {
        this.batchCol = this.batchCol + 1
      } else {
        this.batchCol = this.batchCol - 1
      }
    },
    bnoEnter(e) {
      // console.log(e)
      // 卡号转大写
      e.target.value = e.target.value.toUpperCase()
      // 汉字处理
      this.tipMsg = ''
      let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(e.target.value)) {
        this.tipMsg = '卡号不能有汉字'
        this.tipType = 'error'
        this.cardList = [] // 清空旧数组
        for (let i = 1; i <= this.addCount; i++) {
          let card = {}
          if (this.mdl.type == 1 || this.mdl.type == 3) {
            // 处理IC号
            if (document.getElementById('bic' + i).value) {
              card['icNo'] = document.getElementById('bic' + i).value
            }
          }
          if (this.mdl.type == 2 || this.mdl.type == 3) {
            // 处理id号
            if (document.getElementById('bid' + i).value) {
              card['idNo'] = document.getElementById('bid' + i).value
            }
          }
          if (this.showYS) {
            // 处理印刷号
            if (document.getElementById('bys' + i).value) {
              card['cardNo'] = document.getElementById('bys' + i).value
            }
          }
          this.cardList.push(card)
        }
        this.anewACTD()
        e.target.select()
        return
      }

      // 行内下一个输入
      if (e.path[5].nextElementSibling) {
        let ninput =
          e.path[5].nextElementSibling.firstElementChild.lastElementChild.firstElementChild.firstElementChild
            .firstElementChild
        ninput.focus()
        let ysnos = document.getElementsByClassName('bysno')
        let prevysno
        for (let i = 0; i < ysnos.length; i++) {
          const element = ysnos[i]
          if (element.value) {
            prevysno = element.value
          }
        }
        if (ninput.className.indexOf('bysno') >= 0 && prevysno) {
          // 卡编号时跳过
          if (prevysno.length > 4) {
            let fast = prevysno.substring(0, prevysno.length - 4)
            let last = prevysno.substring(prevysno.length - 4)
            ninput.value = fast + (parseInt(last) + 1 + '')
          } else {
            ninput.value = parseInt(prevysno) + 1
          }

          if (e.path[5].parentNode.nextElementSibling) {
            e.path[5].parentNode.nextElementSibling.firstElementChild.firstElementChild.lastElementChild.firstElementChild.firstElementChild.firstElementChild.focus()
          } else {
            // 完成了提交
            this.handleBatchAddOk()
          }
        }
      } else {
        // 换行下一个输入
        if (e.path[5].parentNode.nextElementSibling) {
          e.path[5].parentNode.nextElementSibling.firstElementChild.firstElementChild.lastElementChild.firstElementChild.firstElementChild.firstElementChild.focus()
        } else {
          // 完成了提交
          this.handleBatchAddOk()
        }
      }
    },
    handleBatchAddOk() {
      this.confirmLoading = true
      this.cardList = [] // 清空旧数组
      for (let i = 1; i <= this.addCount; i++) {
        let card = {}
        let hv = 0
        if (this.mdl.type == 1 || this.mdl.type == 3) {
          // 处理IC号
          if (document.getElementById('bic' + i).value) {
            hv++
            card['icNo'] = document.getElementById('bic' + i).value
          }
        }
        if (this.mdl.type == 2 || this.mdl.type == 3) {
          // 处理id号
          if (document.getElementById('bid' + i).value) {
            hv++
            card['idNo'] = document.getElementById('bid' + i).value
          }
        }
        if (this.showYS) {
          // 处理印刷号
          if (document.getElementById('bys' + i).value) {
            card['cardNo'] = document.getElementById('bys' + i).value
          }
        }
        // 有效卡号才增加发卡记录
        if (hv != 0) {
          card['type'] = this.mdl.type
          this.cardList.push(card)
        }
      }

      let cardstr = JSON.stringify(this.cardList)
      cardSaveBatch({ cardNo: cardstr })
        .then(res => {
          if (res.code === '0') {
            if (res.code === '0') {
              this.$refs.table.refresh()
              this.batchAddModel = false
            }
          } else {
            this.tipMsg = res.message
            this.tipType = 'info'
            this.anewACTD()
          }
        })
        .catch(e => {
          this.anewACTD()
          console.log(e)
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    anewACTD() {
      // 重新渲染页面数聚
      setTimeout(() => {
        for (let i = 0; i < this.cardList.length; i++) {
          const element = this.cardList[i]
          if (document.getElementById('bic' + (i + 1)) && element.icNo) {
            document.getElementById('bic' + (i + 1)).value = element.icNo
          }
          if (document.getElementById('bid' + (i + 1)) && element.idNo) {
            document.getElementById('bid' + (i + 1)).value = element.idNo
          }
          if (document.getElementById('bys' + (i + 1)) && element.cardNo) {
            document.getElementById('bys' + (i + 1)).value = element.cardNo
          }
        }
      }, 500)
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          return cardDelete({ ids: record.id })
            .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            })
            .catch(e => {
              console.log(e)
            })
            .finally(() => {})
        },
        onCancel() {}
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        Bus.$emit('showSpinning', true, '准备导入...')
      }
      if (info.file.status === 'done') {
        Bus.$emit('showSpinning', false)
        if (info.file.response && info.file.response.code === '0') {
          this.$message.success('导入成功！')
          this.$refs.table.refresh()
        } else {
          this.$message.error(info.file.response.message)
        }
      }
    },
    beforeUpload(file) {},
    downLoad() {
      let url = this.config.downLoadMouldUrl + '卡号.xlsx'
      window.location.href = url
    },
    handleExport() {
      var queryNo = this.queryParam.queryNo
      var used = this.queryParam.used
      var type = this.queryParam.type
      if (!queryNo) {
        queryNo = ''
      }
      if (!used) {
        used = ''
      }
      if (!type) {
        type = ''
      }
      const token = Vue.ls.get(ACCESS_TOKEN)
      window.location.href =
        this.config.downloadCardUrl +
        '&accessToken=' +
        token +
        '&queryNo=' +
        queryNo +
        '&used=' +
        used +
        '&type=' +
        type
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
}
</style>
